import {
  Card,
  CardActionArea,
  CardContent,
  Container,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { helpPages } from "./pages";

const HelpIndex = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Stack spacing={1} mb={3}>
        <Typography variant="h4" fontWeight={700}>
          Help centre
        </Typography>
        <Typography color="text.secondary">
          Step-by-step guides for common admin tasks.
        </Typography>
      </Stack>

      <Grid container spacing={2}>
        {helpPages.map((page) => (
          <Grid item xs={12} md={6} key={page.slug}>
            <Card variant="outlined">
              <CardActionArea
                component={RouterLink}
                to={`/help/${page.slug}`}
                sx={{ height: "100%" }}
              >
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {page.title}
                  </Typography>
                  {page.summary && (
                    <Typography variant="body2" color="text.secondary">
                      {page.summary}
                    </Typography>
                  )}
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default HelpIndex;
